// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    border: 'none',
    outline: 'none',
    userSelect: 'none',
    '&:hover': {
      background: theme.palette.ava.red2,
      '& $icon': {
        fill: theme.palette.ava.white,
      },
    },
  },
  icon: {
    fontSize: 30,
    fill: theme.palette.ava.red2,
  },
}));

interface Props {
  className?: string;
  onClick: Function;
}

const CloseButton = ({ className, onClick }: Props) => {
  const classes = useStyles();

  return (
    <button className={classnames(classes.root, className)} onClick={onClick}>
      <CloseIcon className={classes.icon} />
    </button>
  );
};

export default CloseButton;
